import { render, staticRenderFns } from "./DashBoardAdmin.vue?vue&type=template&id=1692dc70"
import script from "./DashBoardAdmin.vue?vue&type=script&lang=js"
export * from "./DashBoardAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashBoardAdmin.vue?vue&type=style&index=0&id=1692dc70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports